import firebase from 'firebase';

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyAQAcD439C_6p7V3N4ZqGLG1HKWLJAceKo',
  authDomain: 'oscar-night.firebaseapp.com',
  databaseURL: 'https://oscar-night.firebaseio.com',
  projectId: 'oscar-night',
  storageBucket: 'oscar-night.appspot.com',
  messagingSenderId: '854745239817'
};
let app = firebase.initializeApp(config);

export const db = app.database();
